module.exports = __webpack_public_path__ + "img/sale-order.54e1be3e.jpg";